import React from 'react';
import moment from 'moment';

const  Notifications = (props) => {
    const { notifications, auth } = props;

    let counter = 0;
    
    return (
        <div className="notifications">
            <h5>Notifications</h5>
            {/* <div className="media"> */}
                <div className="media-body">
                    <ul style={{ margin: "0px", padding: "0px" }}>
                        { notifications && notifications.map(item => {
                            if(item.emailAddress !== auth.email && counter < 10) {
                                counter++;
                                let currentStyle = item.content === 'registered' ? 'info' : 'success';
                                return (
                                    <li key={item.id} style={{  listStyleType: "none" }}>
                                        <div className={"card border-" + currentStyle + " mb-3"}>
                                            {/* <div className={"card-header bg-transparent border-" + currentStyle}>Header</div> */}
                                            <div className={"card-body text-" + currentStyle}>
                                                <h5 className="card-title">{item.user}</h5>
                                                <p className="card-text">{item.content}</p>
                                            </div>
                                            <div className={"card-footer  border-" + currentStyle + " text-" + currentStyle}>{ moment(item.time.toDate()).fromNow() }</div>
                                        </div>


                                        {/* <div className={"notification " + (item.content === 'registered' ? 'notification-user' : 'notification-post')} key={item.id}>
                                                <div className="text-muted">
                                                    <strong className="mr-auto">{item.user}</strong>
                                                    <medium> {item.content} </medium>
                                                    <br />
                                                    <small>{ moment(item.time.toDate()).fromNow() }</small>
                                                </div>
                                        </div> */}
                                    </li>
                                )
                            }
                            })}
                        </ul>
                    </div>
                {/* </div> */}
            </div>
        )
    };    

export default Notifications;
